const PAGE = { width: 794, height: 1123 };
const MARGIN = 28;
const MIN_SCALE = 0.7;

export function printElementToPdf(title, element) {
  const styles = Array.from(
    document.querySelectorAll('link[rel="stylesheet"], style'),
  )
    .map((el) => el.outerHTML)
    .join("\n");

  const contentWidth = PAGE.width - MARGIN * 2;
  const contentHeight = PAGE.height - MARGIN * 2;

  const iframe = document.createElement("iframe");
  Object.assign(iframe.style, {
    position: "fixed",
    top: "0",
    left: "-9999px",
    width: "100%",
    height: "100%",
    border: "none",
  });
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.write(`
    <!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title>
    ${styles}
    <style>
      @media print {
        @page { margin: 10mm; size: A4; }
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        table { page-break-inside: auto; font-size: 10px; border-collapse: collapse; }
        thead { display: table-header-group; }
        tr { page-break-inside: avoid; page-break-after: auto; }
        td, th { padding: 3px 6px !important; font-size: 10px !important; }
        p { font-size: 12px !important; margin: 0 !important; }
        h3 { font-size: 12px !important; margin: 4px 0 !important; }
        b, .font-black { font-weight: 600 !important; font-size: 12px !important; }
        .text-2xl { font-size: 16px !important; margin-bottom: 6px !important; }
        .border-2 { border-width: 1px !important; }
        .py-1 { padding: 2px 0 !important; }
        .py-2 { padding: 4px 0 !important; }
        .py-3 { padding: 6px 0 !important; }
        .px-2 { padding: 0 5px !important; }
        .px-3 { padding: 0 6px !important; }
        .p-4 { padding: 8px !important; }
        .gap-1 { gap: 2px !important; }
        .gap-2 { gap: 4px !important; }
        .gap-3, .gap-4, .gap-5 { gap: 6px !important; }
        .my-3, .my-4 { margin: 5px 0 !important; }
        .mt-2, .mt-3, .mt-4, .mt-5 { margin-top: 5px !important; }
        .rounded, .rounded-md { border-radius: 2px !important; }
        .border-b-2, .border-b-4 { border-bottom-width: 1px !important; }
        .grid { gap: 4px !important; }
        .flex-col { gap: 3px !important; }
        hr { margin: 6px 0 !important; border-width: 1px !important; }
        .no-print { display: none !important; }
      }
      html, body { margin: 0; padding: 0; }
      body { font-family: Arial, sans-serif; }
      #print-scaler { transform-origin: top left; }
    </style></head>
    <body>
      <div id="print-scaler" style="width:${contentWidth}px;">${element.innerHTML}</div>
    </body></html>
  `);
  doc.close();

  const win = iframe.contentWindow;
  const iframeDoc = win.document;

  const fitToOnePage = () => {
    const scaler = iframeDoc.getElementById("print-scaler");
    if (!scaler) return;

    const height = scaler.offsetHeight;
    if (height <= contentHeight) return;

    const scale = contentHeight / height;
    if (scale < MIN_SCALE) return;

    scaler.style.width = contentWidth / scale + "px";
    scaler.style.zoom = scale;
  };

  let printed = false;
  const doPrint = () => {
    if (printed) return;
    printed = true;
    try {
      fitToOnePage();
    } catch (err) {}
    win.focus();
    win.print();
    setTimeout(() => document.body.removeChild(iframe), 1000);
  };

  win.addEventListener("load", () => setTimeout(doPrint, 150));
  setTimeout(doPrint, 2000);
}
